<template>
    <div class="add-services" v-wechat-title="title">
        <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
            <van-cell :value="provinceName" class="inputone" title="省份" required is-link  @click="showProvince = true">
                <template>
                    <div :style="{'color':provinceName=='请选择'?'#969799':'black'}">{{provinceName}}</div>
                </template>
            </van-cell>
            <van-popup  v-model="showProvince" round  position="bottom">
                <van-picker show-toolbar :columns="provinceArr" @cancel="showProvince = false" @confirm="confirmProvince" />
            </van-popup>

            <van-cell :value="cityName" class="inputone" title="城市" required is-link  @click="openCity">
                <template>
                    <div :style="{'color':cityName=='请选择'?'#969799':'black'}">{{cityName}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showCity" round  position="bottom">
                <van-picker show-toolbar :columns="cityArr" @cancel="showCity = false" @confirm="confirmCity" />
            </van-popup>

            <van-cell :value="drugstore" class="inputone" title="发药药房" required is-link  @click="ondrugstore">
                <template>
                    <div :style="{'color':drugstore=='请选择'?'#969799':'black'}">{{drugstore}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showDrugstore" round  position="bottom">
                <van-picker show-toolbar :columns="drugstoreArr" @cancel="showDrugstore = false" @confirm="confirmDrugstore" value-key="name"/>
            </van-popup>

            <van-cell :value="consultingTimeStr" class="inputone" title="发药日期" required is-link  @click="showDatePicker=true">
                <template>
                    <div :style="{'color':consultingTimeStr=='请选择'?'#969799':'black'}">{{consultingTimeStr}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showDatePicker" round position="bottom">
                <van-datetime-picker v-model="consultingDate" type="date" title="" :min-date="minDate" :max-date="maxDate" @confirm="confirmConsultingDate" @cancel="showDatePicker=false"/>
            </van-popup>

            <van-cell :value="recievePerson" class="inputone" title="领药人" required is-link  @click="goPredict_ids">
                <template>
                    <div :style="{'color':recievePerson=='去选择领药人'?'#969799':'black'}">{{recievePerson}}</div>
                </template>
            </van-cell>


        </van-cell-group>

        <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
            <van-cell>
                <template #title>
                    <div >发药现场照片</div>
                    <image-uploader ref="imgUploader" :value="photoArr" @input="getPhoto" title=" " :num="9" @deleteCI="deleteCI" ></image-uploader>
                </template>
            </van-cell>
        </van-cell-group>

        <div class="checkin-btn">
            <van-button @click="next()"  type="info" round block color="#0AA8AF">提交</van-button>
        </div>
	</div>
</template>
<script>
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,
  } from 'vant';
    import { 
      getVolunteerProvinceCity,
      createDrugDispense,
  } from '@/api/publicWelfareStaff' 
    import {
    GetDrugstore,
  } from "@/api/api";
import ImageUploader from "@/views/publicWelfareStaff/ImageUploader";
  Vue.use(Toast);
export default {
    components: {ImageUploader},
	data(){
		return {
            //标题
            title:"新增监督发药",
            //省份
            provinceName:'请选择',
            showProvince:false,
            provinceArr:[],
            //城市
            cityName: '请选择',
            showCity: false,
            cityArr: [],

            //领药药房
            drugstore:'请选择',
            showDrugstore:false,
            drugstoreArr:[],
            //发药日期
            showConsultingDate:false,
            consultingTimeStr:'请选择',
            consultingDate:new Date(),
            showDatePicker:false,
            minDate: new Date(1949, 10, 1),
            maxDate: new Date(),
            //领药人
            predict_ids:[],
            recievePerson:'去选择领药人',
            //发药现场照片
            photoArr:[],

            provinceCity:{},//省份城市数据

		}
	},
	async created() {
        await this.getData()
        if(this.publicWelfareStaff.predict_ids.length > 0){
            this.recievePerson=''
            this.publicWelfareStaff.predict_ids.forEach(ele=>{
                this.recievePerson=this.recievePerson+this.recievePerson?',':''+ele.name
                this.predict_ids.push(ele.id)
            })
            this.recievePerson.slice(1)
            if(this.recievePerson=='') this.recievePerson=='去选择领药人'
        }
        if(this.publicWelfareStaff.newSupervise){
            let {
                // drug_dispense_images,
                province,
                city,
                drugstore_name,
                drugstore_id,
                operate_date,
                // predict_ids,
            }=this.publicWelfareStaff.newSupervise
            // this.photoArr=drug_dispense_images
            this.provinceName=province
            this.cityName=city
            this.drugstore=drugstore_name
            this.drugstore_id=drugstore_id
            this.consultingTimeStr=operate_date
            // this.predict_ids=predict_ids
            
        }
	},
    computed:{
        ...mapState(['publicWelfareStaff']),
    },
	methods:{
        async getData(){
            //获取省份
            await getVolunteerProvinceCity({ 
                volunteer_id:this.publicWelfareStaff.checkin_info.papid
            }).then(res => {
                this.provinceArr = Object.keys(res.data)
                this.provinceCity=res.data
            })
        },
        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day;
        },
        confirmProvince(value){
            // 选中省份 
            this.provinceName=value
            this.cityName="请选择"
            this.drugstore = "请选择"
            this.cityArr=[]
            this.drugstoreArr =[]
            this.showProvince = false

            this.cityArr=this.provinceCity[this.provinceName]
        },
        openCity() {
            if (this.cityArr.length < 1) {
                Toast('请先选择“省份”')
                return
            }
            this.showCity = true
        },
        async confirmCity(value){
            this.cityName=value
            this.drugstore = "请选择"
            this.drugstoreArr =[]
            this.showCity = false

            Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
            let hres = await GetDrugstore({
              province: this.provinceName,
              city: this.cityName
            })
            // console.log(hres.data)
            let drugstoreArr=[]
            hres.data.forEach(ele=>{
                drugstoreArr.push(ele)
            })
            this.drugstoreArr = drugstoreArr
            if (this.drugstoreArr.length < 1) {
              this.drugstoreArr.unshift({ name:'该城市下暂无项目药房' })
            }
            Toast.clear();
        },
        ondrugstore(){
            if (this.drugstoreArr.length < 1) {
                Toast('请先选择“城市”')
                return
            }
            this.showDrugstore=true
        },
        confirmDrugstore(value){
            this.drugstore=value.name
            this.drugstore_id=value.id
            this.showDrugstore = false
        },
        confirmConsultingDate(value){
            // console.log("发药时间",value)
            this.consultingTimeStr=this.timeFormat(value)
            this.showDatePicker=false;
        },

        getPhoto(image){
            console.log("input-get",image)
        },
        deleteCI(){
            Dialog.confirm({
                message: '确定删除？',
            })
            .then(() => {
                // this.photo=[]
            })
        },

		toastText(text){
			Toast(text)
		},
        goPredict_ids(){
            if(!this.drugstore_id){
                Toast('请先选择“发药药房”')
                return
            }
            let saveData={
                // drug_dispense_images:this.photoArr,
                // predict_ids:this.predict_ids,

                province:this.provinceName,
                city:this.cityName,
                drugstore_name:this.drugstore,
                drugstore_id:this.drugstore_id,
                operate_date:this.consultingTimeStr,
                
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
            }
            this.$store.commit("setNewSupervise",saveData)
            this.$router.push({name:'predictIds',query:{drugstore_id:this.drugstore_id}})
        },
		async next(){
            if(this.provinceName=="请选择"){
                Toast("省份不得为空!")
                return
            }
            if(this.cityName=="请选择"){
                Toast("城市不得为空!")
                return
            }

            if(!this.drugstore_id){
                Toast("发药药房不得为空!")
                return
            }
            if(this.consultingTimeStr=="请选择"){
                Toast("发药日期不得为空!")
                return
            }
            if(this.predict_ids.length==0){
                Toast("领药人不得为空!")
                return
            }


            let images_arr = []
            for(let i in this.photoArr){
                images_arr.push(this.photoArr[i].src)
            }
            console.log("photoArr",this.photoArr)
            console.log("images_arr",images_arr)
            console.log("发药现场图片",this.photoArr,images_arr)
            let sendData={
                drug_dispense_images:images_arr,
                predict_ids:this.predict_ids,

                province:this.provinceName,
                city:this.cityName,
                drugstore_name:this.drugstore,
                drugstore_id:this.drugstore_id,
                operate_date:this.consultingTimeStr,
                
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,

            }
            console.log("createDrugDispense发送数据:",sendData)
            // return
            await createDrugDispense(sendData).then(res => {
                if(res.data){
                    this.$store.commit("clearNewSupervise")
                    this.$store.commit("clearPredict_ids")
                    Toast.success('新增成功');
                    this.$router.replace({
                        name: "staffMsg",
                        query:{
                            title:'提交成功',
                            btnText:'返回监督发药页',
                            statusText:'新增监督发药成功',
                            notice:'',
                            // route:this.publicWelfareStaff.originRoute
                        }
                    })
                }
            }).catch((err) => {

            })
	    }
    }
};
</script>

<style lang="less" scoped>
.add-services {
	font-size: 16px;
    min-height: 100vh;
    background-color: #f9f9f9;
    padding-top: 15px;
    .group2{
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        .van-cell__value{
            flex:1.5 0 !important;
        }
        
    }
	.checkin-btn {
      margin: 25px;
    }
    /deep/ .noborder.van-cell::after{
      border-bottom:none !important;
    }



    ::v-deep .black-label{
        span{
            color:#323233;
        }
    }
    ::v-deep .grey-label{
        color:#9D9D9D;
        white-space:nowrap;
    }
}
</style>